import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Container, MenuItem, TextField, Grid } from '@mui/material';
import {useSelector, useDispatch} from 'react-redux';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../components/CustomSnackBar';

import {
  docSubType,
} from '../../../../redux/reducers/DocumentManagement';

const useStyles = makeStyles((theme) => ({
  cancelButton: {
    '&&': {
      color: '#01579B',
      border: '1px solid #01579B',
      marginRight: '10px',
      textTransform: 'none',
      '&:hover': {
        color: '#FFF',
        backgroundColor: '#01579B',
        borderRadius: '5px',
      },
    },
  },
  saveButton: {
    '&&': {
      color: '#FFF',
      background: '#0288D1',
      border: '1px solid #0288D1',
      textTransform: 'none',
      '&:hover': {
        color: '#0288D1',
        backgroundColor: '#FFF',
        borderRadius: '5px',
      },
    },
  },
  helperText: {
    "&&": {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.66,
      textAlign: 'left',
      marginTop: '4px',
      marginRight: '14px',
      marginBottom: 0,
      marginLeft: '14px',
    }
  },
  selectedItemText: {
    "&&": {
      color: '#A9B0BB',
      fontFamily: '"articulat-cf", sans-serif !important',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0.15px',
    }
  }
}));

const EditFile = ({ docId, companyValue, fileTypeValue, descriptionValue, handleCloseDialog, editFileFunction }) => {
  const dispatch = useDispatch();

  const { dropDownData,  subType, errorMsg, successMsg } = useSelector(
    ({documentManagement}) => documentManagement,
  );

  // TODO: Add validation schema here using yup library for form validation 
  // Validation schema for form validation manually because yupResolver is not working with react-hook-form v5 and mui5 using select component
  const [errors, setErrors] = useState({
    company: { isError: false, message: '' },
    fileType: { isError: false, message: '' },
  });

  const [companyArray, setCompanyArray] = useState([]);
  const [fileTypeArray, setFileTypeArray] = useState([]);

  const [company, setCompany] = useState('');
  const [fileType, setFileType] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (dropDownData && dropDownData.DOC_TYPE) {
      const transformedArray = dropDownData.DOC_TYPE.map(item => ({
        companyId: item.id,
        companyValue: item.valueCode,
        companyLabel: item.value,
      }));
      setCompanyArray(transformedArray);
    }
  }, [dropDownData]);

  useEffect(() => {
    handleCompanyChange(companyValue);
  }, []);

  useEffect(() => {
    if (subType) {
      const transformedArray = subType.map(item => ({
        fileTypeId: item.valueCode,
        fileTypeValue: item.value 
      }));
      setFileTypeArray(transformedArray);
    }
  }, [subType]); 

  useEffect(() => {
    if (fileTypeArray.length == 1) {
      setFileType(fileTypeArray[0].fileTypeValue);
    }else {
      if(company != companyValue){
        setFileType('');
      }else {
        setFileType(fileTypeValue);
      }
    }
  }, [fileTypeArray]); 

  const classes = useStyles();

  const handleCompanyChange = (newValue) => {
    setCompany(newValue)
    dispatch(docSubType({
      parentValueCode: newValue,
      childTypeCode: 'SUB_DOC_TYPE',
    }));
    if (newValue) {
      setErrors({ ...errors, company: { isError: false, message: '' } });
    }
  };

  const onSubmit = data => {
    if(!company || !fileType ) {
      setErrors({ ...errors, 
        company: { isError: !company ? true : false, message: !company ? 'Company is required' : '' }, 
        fileType: { isError: !fileType ? true : false, message: !company ? 'File type is required' : '' },
      });
      return;
    }
    editFileFunction(docId,company,fileType,description);
    resetForm();
  };

  const resetForm = () => {
    setCompany('');
    setFileType('');
    setDescription('');
  };

  useEffect(() => {
    setCompany(companyValue);
    setFileType(fileTypeValue);
    setDescription(descriptionValue);
  }, [companyValue, fileTypeValue, descriptionValue]);
  
  return (
    <div className="row">
      <Container maxWidth="sm">
        <form>
          <Grid container sx={{ width: '100%' }}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{ marginRight: '10px', marginTop: '10px' }}>
              <TextField
                onChange={(e) => {handleCompanyChange(e.target.value)}}
                select
                name="company"
                value={company}
                id="company"
                label="Company*"
                error={!!errors.company.isError}
                helperText={errors.company.isError ? errors.company.message : ''}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{ marginRight: '10px'}}
              >
                <MenuItem key="select-company" value="" disabled><span className={classes.selectedItemText}>Select</span></MenuItem>
                {companyArray.map((item) => (
                  <MenuItem key={item.companyId} value={item.companyValue}>{item.companyLabel}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={6} sx={{ marginTop: '10px' }}>
              <TextField
                select
                name="fileType"
                value={fileType}
                id="fileType"
                label="File Type*"
                error={!!errors.fileType.isError}
                helperText={errors.fileType.isError ? errors.fileType.message : ''}
                fullWidth
                onChange={(e) => {setFileType(e.target.value);setErrors({ ...errors, fileType: { isError: false, message: '' } });}}
                size="small"
                InputLabelProps={{ shrink: true }}
              >
                <MenuItem key="select-filetype" value="" disabled> <span className={classes.selectedItemText}>Select</span> </MenuItem>
                {fileTypeArray.map((item) => (
                  <MenuItem key={item.fileTypeId} value={item.fileTypeValue}>
                    {item.fileTypeValue}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ marginTop: '10px', marginBottom: '15px' }}>
              <TextField
                name="description"
                id="description"
                value={description}
                fullWidth
                variant="outlined"
                size="small"
                label="Description"
                InputLabelProps={{ shrink: true }}
                multiline
                onChange={(e) => {setDescription(e.target.value)}}
                rows={1}
              />
            </Grid>
          </Grid>
          <Box display="flex" justifyContent="flex-end" sx={{ marginTop: '10px' }}>
            <Button
              type="button"
              color="inherit"
              size="medium"
              className={classes.cancelButton}
              onClick={(e) => {
                e.stopPropagation();
                handleCloseDialog();
              }}
            >
              Cancel
            </Button>
            <Button type="button" color="inherit" size="medium" onClick={onSubmit} className={classes.saveButton}>
              Save
            </Button>
          </Box>
        </form>
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </Container>
    </div>
  );
};

export default EditFile;
